const invertedMessages = {
  'Learn more about External!': 'external.dashboard.learnMore',
  'Classification In Progress': 'external.dashboard.inprogress.text',
  'We’re processing and tagging all your external employees. This may take a while, and we’ll notify you once the classification is done. An external insight dashboard will be created momentarily. While you’re waiting, you can get to know more about how External would help manage your organization’s employees!':
    'external.dashboard.inprogress.subText',
  'Search external identities': 'external.dashboard.external.placeholder',
  'No users have been classified as external. Please review your external classification rules to ensure they accurately identify external users.':
    'external.dashboard.classification.noIdentities',
};

export default invertedMessages;
